import { api } from './client'
import type { TenantSettings } from './types'

export const settingsApi = {
  get(): Promise<TenantSettings> {
    return api.get<TenantSettings>('/settings')
  },

  update(patch: Partial<TenantSettings>): Promise<TenantSettings> {
    return api.patch<TenantSettings>('/settings', patch)
  },
}
